import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Badge,
  Alert,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LogoutPage from "../auth-pages/LogoutPage";
import ElementPage from "../../Elements";
import { placeCustomerOrderApi } from "../CustomerCRUD";
import { toast } from "react-toastify";
import MemberHeader from "../ramnambook-registration/member-dasboard/MemberHeader";

const CheckoutList = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const navigate = useNavigate();
  const pathUrl = process.env.REACT_APP_API_URL;

  const [memberDts, setMemberDts] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  /* =======================
     LOAD CUSTOMER FROM STORAGE (ONCE)
     ======================= */
  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    if (storedCustomer) {
      setMemberDts(JSON.parse(storedCustomer));
    }
  }, []);

  const isLoggedIn = !!memberDts;

  /* =======================
     CALCULATIONS
     ======================= */
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.qty,
    0
  );

  const finalTotalNumber = Number(totalPrice.toFixed(2));

  /* =======================
     PLACE ORDER
     ======================= */
  const handleProceedOrder = async () => {
    // if (!isLoggedIn) {
    //   navigate("/login");
    //   return;
    // }

    if (cartItems.length === 0) {
      toast.error("Your cart is empty");
      return;
    }

    const existingOrder = localStorage.getItem("pendingOrder");
    if (existingOrder) {
      const order = JSON.parse(existingOrder);
      toast.info("Resuming your pending payment");
      navigate(`/payment/${order.orderID}`);
      return;
    }
    try {
      setLoading(true);
      // setError("");
      const orderPayload = {
        customerID: memberDts.ramNamBookMemberID,
        orderTypeID: 1,
        subTotal: totalPrice,
        finalTotal: finalTotalNumber,
        items: cartItems.map((item) => ({
          productCategoryID: item.prodCatgryID,
          productID: item.id,
          qty: item.qty,
          rateOnOrder: item.price,
          lineTotal: item.price * item.qty,
        })),
      };

      // localStorage.setItem("order", JSON.stringify(orderPayload));
      const res = await placeCustomerOrderApi(orderPayload);

      if (res.data.isSuccess) {
        localStorage.setItem(
          "pendingOrder",
          JSON.stringify({
            orderID: res.data.orderID,
            orderNo: res.data.orderNo,
          })
        );
        toast.success("Order created successfully.Proceed to payment.");
        navigate(`/payment/${res.data.orderID}`, { replace: true });
      } else {
        toast.error("Order failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MemberHeader />
      <div className="py-3 px-4">
        {/* <div className="d-flex justify-content-end mb-3">
          <LogoutPage />
        </div> */}

        {/* =======================
            CUSTOMER INFO
           ======================= */}
        {memberDts && (
          <Card className="p-3 mb-3 shadow-sm text-start">
            <p style={{ color: "#FF4F00" }} className="fs-5">
              👤 Customer Info
            </p>
            <p className="mb-1">
              <strong>{memberDts.memberName}</strong>
            </p>
            <p className="mb-1">📱 {memberDts.mobileNumber}</p>
            <p className="mb-1">{memberDts.villageCityName}</p>
            <p className="mb-1">
              {memberDts.addressAndText} - {memberDts.pincode}
            </p>
            <p className="mb-0">{memberDts.countryName}</p>
          </Card>
        )}

        {/* =======================
            CART
           ======================= */}
        <Row className="g-4">
          <Col md={8}>
            <Card className="p-3 shadow-sm">
              <p className="fs-5">🛒 Your Cart</p>

              {cartItems.length === 0 ? (
                <p className="text-muted text-center">Your cart is empty.</p>
              ) : (
                <>
                  {/* =======================
            DESKTOP TABLE (md+)
           ======================= */}
                  <div className="d-none d-md-block table-responsive">
                    <table className="table align-middle table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Product Category</th>
                          <th>Product Name</th>
                          <th className="text-center">Qty</th>
                          <th className="text-end">Price</th>
                          <th className="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartItems.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={pathUrl + item.image}
                                  alt="img"
                                  className="rounded"
                                  style={{
                                    width: 50,
                                    height: 50,
                                    objectFit: "contain",
                                  }}
                                />
                                <span className="fw-semibold">
                                  {item.categoryName}
                                </span>
                              </div>
                            </td>
                            <td>{item.name}</td>
                            <td className="text-center">
                              <span className="badge bg-secondary">
                                {item.qty}
                              </span>
                            </td>
                            <td className="text-end">₹{item.price}</td>
                            <td className="text-end fw-bold text-success">
                              ₹{item.price * item.qty}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* =======================
                      MOBILE VIEW (sm)
                      ======================= */}
                  <div className="d-block d-md-none">
                    {cartItems.map((item) => (
                      <Card key={item.id} className="mb-3 border shadow-sm">
                        <Card.Body>
                          <div className="d-flex gap-3">
                            <img
                              src={pathUrl + item.image}
                              alt="img"
                              className="rounded"
                              style={{
                                width: 70,
                                height: 70,
                                objectFit: "contain",
                              }}
                            />
                            <div className="flex-grow-1">
                              <p className="mb-1 fw-semibold">{item.name}</p>
                              <small className="text-muted">
                                Category: {item.categoryName}
                              </small>

                              <div className="mt-2 d-flex justify-content-between">
                                <span>
                                  Qty: <b>{item.qty}</b>
                                </span>
                                <span>Price: ₹{item.price}</span>
                              </div>

                              <div className="mt-1 text-end fw-bold text-success">
                                Total: ₹{item.price * item.qty}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </>
              )}
            </Card>
          </Col>

          {/* =======================
               ORDER SUMMARY
              ======================= */}
          <Col md={4}>
            <Card className="p-3 shadow-sm">
              <h6 className="fw-bold mb-3" style={{ color: "#FF4F00" }}>
                📦 Order Summary
              </h6>

              <div className="d-flex justify-content-between mb-2">
                <span>Total Items</span>
                <span>{cartItems.length}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal</span>
                <span>₹{totalPrice.toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Delivery Charges</span>
                <span className="text-success">FREE</span>
              </div>

              <hr />

              <div className="d-flex justify-content-between fw-bold fs-6">
                <span>Total Payable</span>
                <span style={{ color: "#FF4F00" }}>
                  ₹{totalPrice.toFixed(2)}
                </span>
              </div>

              <Button
                className="w-100 mt-3"
                style={{
                  backgroundColor: "#FF4F00",
                  color: "#fff",
                  border: "none",
                }}
                onClick={handleProceedOrder}
                disabled={loading}
              >
                {"Place Order"}
              </Button>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ElementPage /> */}
    </>
  );
};

export default CheckoutList;
